import React, { useRef } from 'react';
import { HStack, Button, Input, useToast, Box } from '@chakra-ui/react';
import { showErrorToast } from '../../util/errorHandler';
import { RepeatIcon, AttachmentIcon } from '@chakra-ui/icons';
import SearchBox from '../../CommonComponents/SearchBox';
import Pagination from './Pagination';
import { common } from '../../constants/constants';

export default function Upload({ onRefresh, onFileUpload,handleSearch,handleClear ,handlePageChange,
  currentPage,
  totalPages,}) {
  const inputRef = useRef(null);
  const toast = useToast();

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const validTypes = [
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-excel',
      'text/csv',
    ];

    if (!validTypes.includes(file.type)) {
      showErrorToast(toast, 'Only .xlsx, .xls, .csv files are allowed.');
      return;
    }

    onFileUpload?.(file);
    e.target.value = ''; // Clear file input
  };

  return (
    <HStack spacing={4} justifyContent={"flex-end"}>
        <Box width={"500px"}>
        <SearchBox onSearch={handleSearch} onClear={handleClear} />
        </Box>
      <Button leftIcon={<RepeatIcon />} onClick={onRefresh} colorScheme="blue">
        {common.REFRESH}
      </Button>
      <Input
        ref={inputRef}
        type="file"
        accept=".xlsx,.xls,.csv"
        display="none"
        onChange={handleFileChange}
      />
      <Button
        leftIcon={<AttachmentIcon />}
        colorScheme="teal"
        onClick={() => inputRef.current?.click()}
      >
       {common.UPLOAD_FILE}
      </Button>
            <Pagination handlePageChange={handlePageChange} currentPage={currentPage} totalPages={totalPages} /> 
      
    </HStack>
  );
}
